module.exports = __webpack_public_path__ + "static/media/ignite_logo.5334de6c.png";